import React from "react";
import { Link } from "react-router-dom";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";
import Swal from "sweetalert2";

class Products extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      buscarProductos: {},
      estatusTramiteCombo: Api.loadCatalogue("cat_estatus_tramite"),
      nivelUsuario: localStorage.nivel_actual,
    };

    this.handleOpenNotaMarginal = this.handleOpenNotaMarginal.bind(this);
    this.handleRegister = this.handleRegister.bind(this);
  }
  anotacionMarginal = "";

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    let grid = {
      source: "app/getSolicitudesProductosClient",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        folio_solicitud: {
          label: "Folio Solicitud",
        },
        accion: {
          label: "Trámite",
          render: (me) => {
            if (me.data.accion !== null) {
              me.innerHTML = me.data.accion;
            } else {
              me.innerHTML = "";
            }
          },
        },
        nombre_comercial: {
          label: "Nombre Comercial",
          render: (me) => {
            if (me.data.nombre_comercial !== null) {
              me.innerHTML = me.data.nombre_comercial;
            } else {
              me.innerHTML = "";
            }
          },
        },
        fabricante: {
          label: "Fabricante",
          render: (me) => {
            if (me.data.fabricante !== null) {
              me.innerHTML = me.data.fabricante;
            } else {
              me.innerHTML = "";
            }
          },
        },
        tipo_producto: {
          label: "Tipo producto",
          render: (me) => {
            if (me.data.tipo_producto !== "Null") {
              me.innerHTML = me.data.tipo_producto;
            } else {
              me.innerHTML = "NA";
            }
          },
        },
        estatus_producto: {
          label: "Estado producto",
          render: (me) => {
            if (me.data.estatus_producto !== null) {
              me.innerHTML = me.data.estatus_producto;
            } else {
              me.innerHTML = "";
            }
          },
        },
        pais: {
          label: "País de origen",
          render: (me) => {
            if (me.data.pais !== null) {
              me.innerHTML = me.data.pais;
            } else {
              me.innerHTML = "";
            }
          },
        },
        no_registro: {
          label: "Número de registro",
          render: (me) => {
            if (me.data.no_registro !== null) {
              me.innerHTML = me.data.no_registro;
            } else {
              me.innerHTML = "";
            }
          },
        },
        fecha_solicitud: {
          label: "Fecha Solicitud",
          render: (me) => {
            me.innerHTML = me.data.fecha_solicitud
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        descripcion: {
          label: "Estado",
          render: (me) => {
            if (
              me.data.estatus_tramite_id === "9" ||
              me.data.estatus_tramite_id === "10" ||
              me.data.estatus_tramite_id === "11" ||
              me.data.estatus_tramite_id === "13" ||
              me.data.estatus_tramite_id === "14"
            ) {
              me.innerHTML = "En espera";
            } else if (
              me.data.estatus_tramite_id === "3" &&
              me.data.tramite_id !== "8"
            ) {
              me.innerHTML = "Llenar producto";
            }
            if (
              me.data.estatus_tramite_id === "3" &&
              me.data.tramite_id === "8"
            ) {
              me.innerHTML = "Llenar anotación marginal";
            }
          },
        },
      },
      buttons: [
        {
          iconClass: "fa fa-list",
          btnClass: "btn bg-gradient-green",
          btnClick: (data) => {
            if (data.producto_id == null && data.tramite_id !== "8") {
              window.location.href =
                "/solicitud/inscripcion-producto/" +
                data.tipo_producto_id +
                "/" +
                data.id;
            }
          },
          render: (me, data) => {
            //
            if (data.estatus_tramite_id !== "3" || data.tramite_id === "8") {
              me.remove();
            }
          },
        },
        {
          iconClass: "fa fa-paperclip",
          btnClass: "btn bg-gradient-blue",
          btnClick: (data) => {
            let params = data;
            Api.loading(true);
            Api.fetch(
              "app/getProductDocs?solicitud_id=" + data.solicitud_id
            ).then((files) => {
              Api.loading(false);
              uploadDocs = Api.upload({
                target: "#cargaDocs",
                required: files.documentos,
                ok: files.aprobados,
                post: "app/setProductDocs",
                exts: ".jpg, .jpeg, .png, .pdf",
                params: params,
                onFinish: (r) => {
                  Swal.fire({
                    title: "Carga de documentos",
                    html: "Carga completa con éxito",
                    icon: "success",
                  });

                  modalarchivos.close();

                  mi_grid.go(0); // ir a la pagina actual - refrescar el grid
                },
              });

              let modalarchivos = Api.modal({
                title: "Documentación requerida",
                html: uploadDocs,
              });
            });
          },
          render: (me, data) => {
            if (
              data.estatus_tramite_id !== "7" &&
              data.estatus_tramite_id !== "6"
            ) {
              me.remove();
            }
          },
        },
        {
          //NOTAS MARGINALES
          iconClass: "fa fa-list",
          btnClass: "btn bg-gradient-red",
          btnClick: (data) => {
            this.handleOpenNotaMarginal(data);
          },
          render: (me, data) => {
            if (
              data.tramite_id !== "8" ||
              (data.estatus_tramite_id !== "3" && data.tramite_id === "8")
            ) {
              me.remove();
            }
          },
        },
      ],
    };

    let mi_grid = Api.grid(grid);

    let formaAnotacion = {
      target: "#anotacionM",
      nombre: "forma",
      elementClass: "form-control",
      render: (me) => {},
      elements: [
        {
          input: {
            cols: 12,
            name: "anotacion",
            type: "text",
            label: "Ingrese anotación marginal",
            placeHolder: "",
          },
        },
      ],
    };

    this.anotacionMarginal = Api.form(formaAnotacion);

    let uploadDocs = {};

    let busqueda = Api.form({
      target: "#busqueda",
      /*onchange: (me, data, serial) => {
                mi_grid.go(1, serial);
            },*/
      render: (form) => {
        /** Cargamos el combo de pais */
        let paises = Api.loadCatalogue("countries");
        let option_p = "<option value=0>Seleccione país</option>";
        for (let p in paises) {
          option_p += `<option value="${paises[p].id}">
                        ${paises[p].descripcion}
                    </option>`;
        }
        form.querySelector("#pais").innerHTML = option_p;
        /* Fin de la carga país */

        /** Cargamos el combo de estatus */
        Api.fetch("app/getEstatusProducto").then((data) => {
          if (data) {
            let estatus = data;
            let option_e = `<option value="0">Seleccione el estatus producto</option>`;
            for (let e in estatus) {
              option_e += `<option value="${estatus[e].id}">${estatus[e].descripcion}</option>`;
            }
            form.querySelector("#estatus").innerHTML = option_e;
          }
        });
        /* Fin de la carga estatus */
      },

      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "nombre_comercial",
            label: "Nombre comercial",
            placeHolder: "Nombre comercial",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "fabricante",
            label: "Fabricante",
            placeHolder: "Fabricante",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "pais",
            label: "País de origen",
            placeHolder: "País de origen",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "number",
            name: "no_registro",
            label: "Número de registro",
            placeHolder: "Número de registro",
            cols: 3,
            value: "",
            autoComplete: "off",
            maxLength: "4",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha desde",
            cols: 2,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha hasta",
            cols: 2,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "estatus",
            label: "Estado producto",
            placeHolder: "Estado producto",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            cols: 3,
            name: "estado",
            label: "Estado solicitud",
            render: (me) => {
              me.innerHTML = `<option value="">Seleccione</option>`;
              let array_mostrar = [1,3,4,5,6,7,8,15,16];
                this.state.estatusTramiteCombo.forEach(s=>{
                  if(array_mostrar.includes(parseInt(s.id))){
                    if(s.id === "3"){ s.descripcion = "Llenar "}
                    me.innerHTML += `<option value=${s.id}>${s.descripcion}</option>`;
                  }
                });
            },
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscarProductos: busqueda.data() });
              let search = this.state.buscarProductos;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              mi_grid.go(1, src);
            },
          },
        },
      ],
    });
  }

  handleOpenNotaMarginal(e) {
    let detalle = document.querySelector("#anotacionM");

    detalle.querySelector(".anotacion label").innerHTML = e.anotacion_marginal;

    this.anotacionMarginal.clear();
    Swal.fire({
      title: "Ingrese anotación marginal",
      html: this.anotacionMarginal,
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      confirmButtonColor: "#5cb85c",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      cancelButtonText: "Regresar",
      preConfirm: () => {
        let dataForm = this.anotacionMarginal.data();
        let pass = 1;

        if (dataForm.anotacion === "" || !dataForm.anotacion) {
          Swal.showValidationMessage("Ingrese la anotación");
          pass = 0;
        }

        if (pass) {
          let data = {
            anotacion: dataForm.anotacion,
            rsam_id: e.rsam_id,
          };
          return Api.fetch("app/updatePeticionAMP", data, "POST")
            .then((data) => this.handleRegister(data))
            .catch((error) => {
              error.json().then((message) => {
                this.setState({ procesando: false });
                Swal.fire({
                  title: "Ocurrió un error al procesar el usuario",
                  icon: "error",
                  text: "Revise la información e intente de nuevo su última acción", //message,
                });
              }); //catching errors to show notification
            });
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  }

  handleRegister(e) {
    if (e.message !== "La solicitud de anotación marginal ha sido enviada correctamente.") {
      Swal.fire({
        title: "Atención, verifique el formulario.",
        icon: "error",
        //html: tplErrors,
      });
    } else {
      Swal.fire({
        title: "Solicitud enviada",
        icon: "success",
        text: e.message,
      }).then(() => {
        window.location.reload();
      });
    }
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item active">Productos</li>
        </ol>
        <h1 className="page-header">Productos</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="myGrid"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>
        <div className="hide">
          <fieldset id="cargaDocs"></fieldset>
        </div>
        <template>
          <div id="anotacionM"></div>
        </template>
      </div>
    );
  }
}

export default Products;
